import { Icon, type IconName } from "./Icon";
import { Modal } from "./Modal";

export function ConfirmationDialog({
  title,
  description,
  confirmLabel,
  busy,
  busyLabel = "Working…",
  destructive = true,
  error = "",
  icon = "rotate",
  onCancel,
  onConfirm,
}: {
  title: string;
  description: string;
  confirmLabel: string;
  busy: boolean;
  busyLabel?: string;
  destructive?: boolean;
  /** A failed confirmation keeps the dialog open, so it reports its own error. */
  error?: string;
  icon?: IconName;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      closeDisabled={busy}
      eyebrow="Confirm change"
      onClose={onCancel}
      title={title}
      titleId="confirmation-dialog-title"
    >
      <div className="confirmation-dialog__body">
        <span className="confirmation-dialog__icon">
          <Icon name="warning" size={20} />
        </span>
        <p>{description}</p>
      </div>
      {error && (
        <div
          className="notice notice--error confirmation-dialog__error"
          role="alert"
        >
          {error}
        </div>
      )}
      <footer className="dialog__actions">
        <button
          className="button button--secondary"
          disabled={busy}
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>
        <button
          className={`button ${destructive ? "button--danger" : "button--primary"}`}
          disabled={busy}
          onClick={onConfirm}
          type="button"
        >
          <Icon name={icon} size={16} />
          {busy ? busyLabel : confirmLabel}
        </button>
      </footer>
    </Modal>
  );
}
